// actions/reviewActions.js

import {
    FETCH_REVIEWS_REQUEST,
    FETCH_REVIEWS_SUCCESS,
    FETCH_REVIEWS_FAILURE,
  } from "./types";
  
  import { fetchReviews } from "../../services/reviewService"; // assuming you have a service for reviews
  
  // Action Creators
  export const fetchReviewsRequest = () => ({ type: FETCH_REVIEWS_REQUEST });
  
  export const fetchReviewsSuccess = (reviewsData) => ({
    type: FETCH_REVIEWS_SUCCESS,
    payload: reviewsData,
  });
  
  export const fetchReviewsFailure = (error) => ({
    type: FETCH_REVIEWS_FAILURE,
    payload: error,
  });
  
  // Thunk to fetch reviews
  export const fetchReviewsAction = (
    filterField = null,
    filterValue = null,
    page = 1,
    size = 50
  ) => async (dispatch) => {
    dispatch(fetchReviewsRequest());
  
    try {
      const response = await fetchReviews(filterField, filterValue, page, size);
  
      if (response.error) {
        dispatch(fetchReviewsFailure(response.error));
        return { success: false, error: response.error };
      } else {
        dispatch(fetchReviewsSuccess(response));
        return { success: true, data: response };
      }
    } catch (error) {
      dispatch(fetchReviewsFailure(error.message || "Failed to fetch reviews"));
      return { success: false, error: error.message || "Failed to fetch reviews" };
    }
  };
  